// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @constants
const { GET_TOPBAR_IN_PROGRESS, GET_TOPBAR_SUCCESS } = require('constants/actionTypes');
const LANGUAGES = ['es', 'en', 'pt', 'nl', 'fr', 'de'];

// @actions
const collectivesAction = require('./collectives');

const getTopbarInProgress = () => ({
    type: GET_TOPBAR_IN_PROGRESS
});

const getTopbarSuccess = topbarData => ({
    type: GET_TOPBAR_SUCCESS,
    payload: {
        response: {
            topbarData
        }
    }
});

const getTopbar = (lang, onError) => dispatch => {
    dispatch(getTopbarInProgress());
    return APIGet({
        url: apiURLBuilder.getURL('topbar'),
        params: {
            header: {
                version: 2
            },
            query: {
                language: LANGUAGES.includes(lang) ? lang : 'es'
            }
        }
    }).then(response => {
        dispatch(getTopbarSuccess(response));
        dispatch(collectivesAction.setCollectivesData(response.topbar.collectives));
    }).catch(e => onError && onError(e));
}

module.exports = {
    getTopbar
};
